(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('MedalDetailController', MedalDetailController);

    MedalDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Medal'];

    function MedalDetailController($scope, $rootScope, $stateParams, previousState, entity, Medal) {
        var vm = this;

        vm.medal = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:medalUpdate', function(event, result) {
            vm.medal = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
